
/**
  Auto-generated by tools/generate-typescript-schemas.ts from
  crysknife-version: crysknife_lib 0.5.102 (ff50b61)


  Do not modify these files by hand, they will get overwritten by future code generations
*/

/** An identifier for reference, usually in the form of a hash **/
export type ReferenceId = string;

export type Angle = number;

/**
 * Arc geometry defined by center, radius, start and end angles, and endpoint coordinates.
 */
export type ArcGeometry = {
    center: Point;
    radius_pair: Point;
    bounds_tag: BoundsTag;
    start_angle: Angle;
    end_angle: Angle;
    start_point: Point;
    end_point: Point;
    [k: string]: unknown | undefined;
};

export type Attribute = {
    name: string;
    value?: string | null;
    display_text?: string | null;
    symbol: SymbolRef;
    position: Point;
    is_visible: boolean;
    show_name?: boolean;
    orientation: Angle;
    justification: TextJustification;
    color: Color;
    font_id: FontId;
    [k: string]: unknown | undefined;
};

/**
 * Attribute identifier.
 */
export type AttributeId = string;

export type Bezier = {
    id: BezierId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    line_width: Length;
    line_style?: LineStyle;
    points: Point[];
    is_filled: boolean;
    fill_color: Color;
    [k: string]: unknown | undefined;
};

/**
 * Bezier curve identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type BezierId = string;

export type Bitmap = {
    id: BitmapId;
    symbol: SymbolRef;
    bottom_left: Point;
    width: Length;
    height: Length;
    is_visible?: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Bitmap identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type BitmapId = string;

export type Border = {
    line_width: Length;
    padding: Length;
    [k: string]: unknown | undefined;
};

export const BORDER_LABEL_DIGITS = {
    UPPERCASE_ALPHABET: "UppercaseAlphabet",
    ARABIC_NUMERAL: "ArabicNumeral"
} as const;
export type BorderLabelDigits = (typeof BORDER_LABEL_DIGITS)[keyof typeof BORDER_LABEL_DIGITS];

export type BorderLabelFormat = {
    width: Length;
    /**
     * @format uint32
     * @minimum 0
     */
    count: number;
    numbering: BorderLabelDigits;
    ascending: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Indicates whether arc bounds were stored as angles or points in the source.
 */
export const BOUNDS_TAG = {
    ANGLE: "angle",
    POINT: "point"
} as const;
export type BoundsTag = (typeof BOUNDS_TAG)[keyof typeof BOUNDS_TAG];

export const CAD_DOCUMENT_TYPE = {
    PROJECT: "Project",
    PCB: "Pcb",
    PCB_COMPONENT_LIBRARY: "PcbComponentLibrary",
    SCHEMATIC: "Schematic",
    SCHEMATIC_COMPONENT_LIBRARY: "SchematicComponentLibrary"
} as const;
export type CadDocumentType = (typeof CAD_DOCUMENT_TYPE)[keyof typeof CAD_DOCUMENT_TYPE];

export type ChangePath = string;

/**
 * @pattern ^#[0-9a-f]{6}([0-9a-f]{2})?$
 */
export type Color = string;

export type ComponentFlags = {
    exclude_from_bom?: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Component identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type ComponentId = string;

/**
 * Component record paired with its associated parts.
 */
export type ComponentInstance = {
    id: ComponentId;
    part_id?: string | null;
    designator?: string | null;
    schematic_link?: string | null;
    description?: string | null;
    position?: Point | null;
    footprint_lib?: string | null;
    locked?: boolean;
    arcs: Record<PcbArcId, PcbArc>;
    tracks: Record<TrackId, Track>;
    pads: Record<PadId, Pad>;
    vias: Record<ViaId, Via>;
    regions: Record<RegionId, Region>;
    texts: Record<PcbTextId, PcbText>;
    [k: string]: unknown | undefined;
};

export type ComponentLink = {
    path: string;
    display_text: string;
    [k: string]: unknown | undefined;
};

export type ContainerChange<T> = {
    base_path?: ChangePath;
    children?: {
        [k: string]: DiffNode<T> | undefined;
    };
};

/**
 * Corner radius for rectangles.
 */
export type CornerRadius = "None" | {
    Circular: {
        radius: Meters;
        [k: string]: unknown | undefined;
    };
} | {
    Xy: {
        radius_x: Meters;
        radius_y: Meters;
        [k: string]: unknown | undefined;
    };
};

export type Crysknife = {
    [k: string]: unknown | undefined;
};

export type CustomPadDrawingOption = "Filled" | {
    Outline: {
        stroke_width: Meters;
        [k: string]: unknown | undefined;
    };
};

export type CustomPadShape = {
    geometry: Path;
    drawing_options: CustomPadDrawingOption;
    [k: string]: unknown | undefined;
};

export type Degree = "degree";

/**
 * A diffed document, tagged by document type. Mirrors
 * [`ManifestDocumentExport`] but carries the diff outputs instead of a
 * single rendering. All paths are relative to the output directory and use
 * forward slashes.
 *
 * One variant per document type even where the fields currently coincide:
 * the shapes are expected to diverge as each type grows outputs of its own.
 */
export type DiffManifestDocumentExport = {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    /**
     * The per-page schematic diff JSON. Omitted if null.
     */
    page_diff_json?: string | null;
    type: "schematic";
    [k: string]: unknown | undefined;
} | {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    type: "pcb";
    [k: string]: unknown | undefined;
} | {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    type: "pcb_component_library";
    [k: string]: unknown | undefined;
} | {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    type: "schematic_component_library";
    [k: string]: unknown | undefined;
};

/**
 * A diffed document, tagged by document type. Mirrors
 * [`ManifestDocumentExport`] but carries the diff outputs instead of a
 * single rendering. All paths are relative to the output directory and use
 * forward slashes.
 *
 * One variant per document type even where the fields currently coincide:
 * the shapes are expected to diverge as each type grows outputs of its own.
 */
export type DiffManifestDocumentExport1 = {
    status: "modified";
    [k: string]: unknown | undefined;
} & ({
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    /**
     * The per-page schematic diff JSON. Omitted if null.
     */
    page_diff_json?: string | null;
    type: "schematic";
    [k: string]: unknown | undefined;
} | {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    type: "pcb";
    [k: string]: unknown | undefined;
} | {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    type: "pcb_component_library";
    [k: string]: unknown | undefined;
} | {
    name: string;
    diff_from_svg: string;
    diff_to_svg: string;
    diff_json: string;
    type: "schematic_component_library";
    [k: string]: unknown | undefined;
});

/**
 * One entry in a [`DiffManifestExport`], tagged by how the document changed.
 *
 * A `Modified` document is present on both sides and its two sides differ, so
 * it carries a [`DiffManifestDocumentExport`] of diff outputs. An `Unchanged`
 * document is present on both sides with identical sides: nothing is written for
 * it, since its rendering is the one the head commit's project view already
 * produces, so the entry carries only its identity. An `Added` or `Removed`
 * document is rendered as a preview of its single present side, identical to a
 * project-view document, so it reuses [`ManifestDocumentExport`]. A `Failed`
 * document could not be produced because a side failed to read or parse; it
 * reuses [`ManifestDocumentExport`]'s failed shape. The inner type tag (`type`)
 * is merged alongside the `status` tag.
 */
export type DiffManifestEntryExport = DiffManifestDocumentExport1 | {
    /**
     * The kind of document, as its file-name-safe label (`schematic`,
     * `pcb`, ...) — the same form [`ManifestDocumentExport::Failed`] uses,
     * the other entry with no outputs to tag by type.
     */
    document_type: string;
    name: string;
    status: "unchanged";
    [k: string]: unknown | undefined;
} | ManifestDocumentExport | ManifestDocumentExport1 | ManifestDocumentExport2;

/**
 * Top-level project-diff manifest export: the set of documents a project diff
 * produced, written to `manifest.json` alongside the per-document output files.
 *
 * Like [`ManifestExport`] this is an index of an export rather than a document
 * payload, so it carries no `format_kind`.
 */
export type DiffManifestExport = {
    documents: DiffManifestEntryExport[];
    /**
     * The base-side input files consumed while producing this diff, in sorted
     * order. Paths are relative to the repo root and use forward slashes as
     * path separator.
     */
    base_used_files: string[];
    /**
     * The head-side input files consumed, in the same form as
     * [`base_used_files`](Self::base_used_files).
     */
    head_used_files: string[];
    [k: string]: unknown | undefined;
};

export type DiffNode<T> = (LeafChange<T> | ContainerChange<T>) | undefined;

export type DiffOutcome<T> = DiffStatus | {
    [k: string]: DiffNode<T> | undefined;
};

/**
 * Outcome of a whole-document comparison: the document was unchanged, added, or removed entirely.
 */
export const DIFF_STATUS = {
    SAME: "Same",
    ADD: "Add",
    REMOVE: "Remove"
} as const;
export type DiffStatus = (typeof DIFF_STATUS)[keyof typeof DIFF_STATUS];

export type DirectiveLabel = {
    id: DirectiveLabelId;
    position: Point;
    color: Color;
    orientation: PinOrientation;
    name?: string | null;
    style: ParameterSetStyle;
    attributes?: Record<ReferenceId, Attribute>;
    [k: string]: unknown | undefined;
};

/**
 * Directive label identifier.
 */
export type DirectiveLabelId = string;

export type DocumentOutput = PcbComponentLibExport | PcbExport | ProjectEntryExport | SchematicComponentLibExport | SchematicExport;

export type Ellipse = {
    id: EllipseId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    line_width: Length;
    line_style?: LineStyle;
    is_filled: boolean;
    fill_color: Color;
    center: Point;
    radius: Point;
    is_transparent: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Ellipse identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type EllipseId = string;

export type ExternalDesignBlock = {
    id: string;
    /**
     * Relative to the project root. Uses forward slashes as path separator.
     */
    path: string;
    [k: string]: unknown | undefined;
};

/**
 * Font definition.
 */
export type Font = {
    family: string;
    pt: Pt;
    /**
     * @format double
     */
    weight: number;
    letter_spacing?: Pt | null;
    stroke_width?: Meters | null;
    is_italic: boolean;
    is_bold: boolean;
    decorations: TextDecorations;
    is_truetype: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Font identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type FontId = string;

export type Graphics = {
    polylines: Record<ReferenceId, Polyline>;
    polygons: Record<ReferenceId, Polygon>;
    rectangles: Record<ReferenceId, Rectangle>;
    arcs: Record<ReferenceId, SchArc>;
    ellipses: Record<ReferenceId, Ellipse>;
    beziers: Record<ReferenceId, Bezier>;
    bitmaps: Record<ReferenceId, Bitmap>;
    texts: Record<ReferenceId, SchText>;
    [k: string]: unknown | undefined;
};

export type Harness = {
    id: HarnessId;
    position: Point;
    width: Length;
    height: Length;
    connector_side: HarnessConnectorSide;
    connection_position: Length;
    color: Color;
    area_color: Color;
    line_width: Length;
    name?: HarnessLabel | null;
    harness_entries?: Record<ReferenceId, HarnessEntry>;
    [k: string]: unknown | undefined;
};

export const HARNESS_CONNECTOR_SIDE = {
    RIGHT: "Right",
    LEFT: "Left",
    UP: "Up",
    DOWN: "Down"
} as const;
export type HarnessConnectorSide = (typeof HARNESS_CONNECTOR_SIDE)[keyof typeof HARNESS_CONNECTOR_SIDE];

export type HarnessEntry = {
    id: HarnessEntryId;
    name: string;
    display_name?: RichText | null;
    distance_from_top: Length;
    text_color: Color;
    font_id: FontId;
    [k: string]: unknown | undefined;
};

/**
 * Harness entry identifier.
 */
export type HarnessEntryId = string;

/**
 * Harness identifier.
 */
export type HarnessId = string;

export type HarnessLabel = {
    text: string;
    position: Point;
    orientation: Angle;
    color: Color;
    font_id: FontId;
    is_visible: boolean;
    [k: string]: unknown | undefined;
};

export const HORIZONTAL_JUSTIFICATION = {
    LEFT: "Left",
    CENTER: "Center",
    RIGHT: "Right"
} as const;
export type HorizontalJustification = (typeof HORIZONTAL_JUSTIFICATION)[keyof typeof HORIZONTAL_JUSTIFICATION];

/**
 * Image data identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type ImageId = string;

export type Junction = {
    id: JunctionId;
    position: Point;
    color: Color;
    diameter: Length;
    [k: string]: unknown | undefined;
};

/**
 * Junction identifier.
 */
export type JunctionId = string;

/**
 * PCB layer. The `is_visible` field is omitted when `true` (visible is the default).
 */
export type Layer = {
    id: LayerId;
    name: string;
    /**
     * @default false
     */
    is_visible?: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Layer identifier.
 *
 * @format uint32
 * @minimum 0
 */
export type LayerId = number;

export type LeafChange<T> = {
    diff_kind: "Add";
} | {
    diff_kind: "Remove";
    base_value: T;
} | {
    diff_kind: "Change";
    base_value: T;
    head_value: T;
};

export type Length = number;

export const LINE_STYLE = {
    SOLID: "solid",
    DASHED: "dashed",
    DOTTED: "dotted",
    DASH_DOT: "dash_dot",
    DASH_DOT_DOT: "dash_dot_dot",
    DENSE_DOT: "dense_dot"
} as const;
export type LineStyle = (typeof LINE_STYLE)[keyof typeof LINE_STYLE];

/**
 * One entry in a [`ManifestExport`], tagged by document type. `json` is
 * the path of the JSON file of the document. A schematic has the SVG
 * rendering of each page in `pages`. Every other document has one SVG
 * rendering in `svg`. All paths are relative to the output directory.
 */
export type ManifestDocumentExport = {
    status: "added";
    [k: string]: unknown | undefined;
} & ({
    name: string;
    json: string;
    /**
     * The SVG rendering of each page, in the same order as the pages
     * of the schematic document.
     */
    pages: ManifestPageExport[];
    type: "schematic";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb_component_library";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "schematic_component_library";
    [k: string]: unknown | undefined;
} | {
    /**
     * The kind of document that failed, as its file-name-safe label
     * (`schematic`, `pcb`, ...).
     */
    document_type: string;
    name: string;
    /**
     * The document's source file relative to the project root, when it has
     * a single one. Omitted for composite documents. Uses forward slashes
     * as path separator.
     */
    file_path?: string | null;
    detail: string;
    type: "failed";
    [k: string]: unknown | undefined;
});

/**
 * One entry in a [`ManifestExport`], tagged by document type. `json` is
 * the path of the JSON file of the document. A schematic has the SVG
 * rendering of each page in `pages`. Every other document has one SVG
 * rendering in `svg`. All paths are relative to the output directory.
 */
export type ManifestDocumentExport1 = {
    status: "removed";
    [k: string]: unknown | undefined;
} & ({
    name: string;
    json: string;
    /**
     * The SVG rendering of each page, in the same order as the pages
     * of the schematic document.
     */
    pages: ManifestPageExport[];
    type: "schematic";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb_component_library";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "schematic_component_library";
    [k: string]: unknown | undefined;
} | {
    /**
     * The kind of document that failed, as its file-name-safe label
     * (`schematic`, `pcb`, ...).
     */
    document_type: string;
    name: string;
    /**
     * The document's source file relative to the project root, when it has
     * a single one. Omitted for composite documents. Uses forward slashes
     * as path separator.
     */
    file_path?: string | null;
    detail: string;
    type: "failed";
    [k: string]: unknown | undefined;
});

/**
 * One entry in a [`ManifestExport`], tagged by document type. `json` is
 * the path of the JSON file of the document. A schematic has the SVG
 * rendering of each page in `pages`. Every other document has one SVG
 * rendering in `svg`. All paths are relative to the output directory.
 */
export type ManifestDocumentExport2 = {
    status: "failed";
    [k: string]: unknown | undefined;
} & ({
    name: string;
    json: string;
    /**
     * The SVG rendering of each page, in the same order as the pages
     * of the schematic document.
     */
    pages: ManifestPageExport[];
    type: "schematic";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb_component_library";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "schematic_component_library";
    [k: string]: unknown | undefined;
} | {
    /**
     * The kind of document that failed, as its file-name-safe label
     * (`schematic`, `pcb`, ...).
     */
    document_type: string;
    name: string;
    /**
     * The document's source file relative to the project root, when it has
     * a single one. Omitted for composite documents. Uses forward slashes
     * as path separator.
     */
    file_path?: string | null;
    detail: string;
    type: "failed";
    [k: string]: unknown | undefined;
});

/**
 * One entry in a [`ManifestExport`], tagged by document type. `json` is
 * the path of the JSON file of the document. A schematic has the SVG
 * rendering of each page in `pages`. Every other document has one SVG
 * rendering in `svg`. All paths are relative to the output directory.
 */
export type ManifestDocumentExport3 = {
    name: string;
    json: string;
    /**
     * The SVG rendering of each page, in the same order as the pages
     * of the schematic document.
     */
    pages: ManifestPageExport[];
    type: "schematic";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "pcb_component_library";
    [k: string]: unknown | undefined;
} | {
    name: string;
    json: string;
    svg: string;
    type: "schematic_component_library";
    [k: string]: unknown | undefined;
} | {
    /**
     * The kind of document that failed, as its file-name-safe label
     * (`schematic`, `pcb`, ...).
     */
    document_type: string;
    name: string;
    /**
     * The document's source file relative to the project root, when it has
     * a single one. Omitted for composite documents. Uses forward slashes
     * as path separator.
     */
    file_path?: string | null;
    detail: string;
    type: "failed";
    [k: string]: unknown | undefined;
};

/**
 * Top-level project-view manifest export: the set of documents a project view
 * produced, written to `manifest.json` alongside the per-document JSON files.
 *
 * This is the index of a project-view export, not a document payload itself, so
 * it carries no `format_kind`.
 */
export type ManifestExport = {
    documents: ManifestDocumentExport3[];
    /**
     * The input files consumed while producing this project view, in sorted
     * order. Paths are relative to the repo root and use forward slashes as
     * path separator.
     */
    used_files: string[];
    /**
     * Non-fatal warnings produced while building the project view.
     */
    warnings: Warning[];
    [k: string]: unknown | undefined;
};

/**
 * A page of a schematic document and the SVG rendering of that page alone.
 * `svg` is relative to the output directory.
 */
export type ManifestPageExport = {
    id: SchematicPageId;
    svg: string;
    [k: string]: unknown | undefined;
};

/**
 * Length in meters.
 *
 * @format double
 */
export type Meters = number;

export type Millimeter = "mm";

export type Net = {
    id: NetId;
    name?: string | null;
    [k: string]: unknown | undefined;
};

/**
 * Net identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type NetId = string;

/**
 * A net label: a positioned piece of text that names an electrical net.
 *
 * Unlike a [`WireAlias`], a net label is a standalone, page-level object and
 * is not necessarily attached to a wire.
 */
export type NetLabel = {
    net_id?: NetId | null;
    position: Point;
    color: Color;
    font_id: FontId;
    justification: TextJustification;
    orientation: Angle;
    name: string;
    display_text?: RichText | null;
    is_visible: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Net label identifier.
 */
export type NetLabelId = string;

export type NoConnectSymbol = {
    position: Point;
    net_id?: NetId | null;
    [k: string]: unknown | undefined;
};

/**
 * No-connect symbol identifier.
 */
export type NoConnectSymbolId = string;

/**
 * Pad instance.
 */
export type Pad = {
    designator: string;
    center: Point;
    rotation: Angle;
    padstack: PadstackId;
    net_id?: NetId | null;
    net_name?: string | null;
    [k: string]: unknown | undefined;
};

export type PadHole = {
    offset: Point;
    rotation: Angle;
    hole: PadHoleShape;
    [k: string]: unknown | undefined;
};

export type PadHoleCircle = {
    radius: Length;
    [k: string]: unknown | undefined;
};

export type PadHoleRectangle = {
    width: Length;
    height: Length;
    [k: string]: unknown | undefined;
};

export type PadHoleShape = {
    Circle: PadHoleCircle;
} | {
    Slot: PadHoleSlot;
} | {
    Rectangle: PadHoleRectangle;
};

export type PadHoleSlot = {
    width: Length;
    height: Length;
    [k: string]: unknown | undefined;
};

/**
 * Pad identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type PadId = string;

export type PadShape = {
    Circle: PadShapeCircle;
} | {
    Pill: PadShapePill;
} | {
    Rectangle: PadShapeRectangle;
} | {
    Octagon: PadShapeOctagon;
} | {
    Custom: CustomPadShape[];
};

export type PadShapeCircle = {
    radius: Length;
    [k: string]: unknown | undefined;
};

export type PadShapeOctagon = {
    width: Length;
    height: Length;
    [k: string]: unknown | undefined;
};

export type PadShapePill = {
    width: Length;
    height: Length;
    [k: string]: unknown | undefined;
};

export type PadShapeRectangle = {
    width: Length;
    height: Length;
    x_radius: Length;
    y_radius: Length;
    [k: string]: unknown | undefined;
};

/**
 * Padstack definition.
 */
export type Padstack = {
    name?: string | null;
    layers: Record<LayerId, PadstackLayer>;
    hole?: PadHole | null;
    [k: string]: unknown | undefined;
};

/**
 * Padstack identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type PadstackId = string;

export type PadstackLayer = {
    shape: PadShape;
    offset: Point;
    [k: string]: unknown | undefined;
};

export type PageBorder = {
    stroke_width: Length;
    margin: PageBorderMargin;
    horizontal_label: BorderLabelFormat;
    vertical_label: BorderLabelFormat;
    [k: string]: unknown | undefined;
};

export type PageBorderMargin = {
    left: Length;
    right: Length;
    top: Length;
    bottom: Length;
    [k: string]: unknown | undefined;
};

export const PARAMETER_SET_STYLE = {
    LARGE: "Large",
    TINY: "Tiny",
    DIFFERENTIAL_PAIR: "DifferentialPair"
} as const;
export type ParameterSetStyle = (typeof PARAMETER_SET_STYLE)[keyof typeof PARAMETER_SET_STYLE];

export type Path = {
    start: Point;
    [k: string]: unknown | undefined;
};

/**
 * Arc geometry. Contains both angle-based and point-based bounds.
 */
export type PcbArc = {
    center: Point;
    radius_pair: Point;
    bounds_tag: BoundsTag;
    start_angle: Angle;
    end_angle: Angle;
    start_point: Point;
    end_point: Point;
    line_width: Length;
    layer_id: LayerId;
    net_id?: NetId | null;
    net_name?: string | null;
    [k: string]: unknown | undefined;
};

/**
 * PCB arc identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type PcbArcId = string;

export type PcbComponentLibDocumentType = "PcbComponentLib";

/**
 * Top-level PCB component library export.
 */
export type PcbComponentLibExport = {
    type: PcbComponentLibDocumentType;
    components: PcbLibraryComponentSchema[];
    [k: string]: unknown | undefined;
};

export type PcbDocumentType = "Pcb";

/**
 * Top-level PCB export.
 */
export type PcbExport = {
    type: PcbDocumentType;
    layers: Record<LayerId, Layer>;
    preset_layers: Record<string, LayerId[]>;
    component_instances: Record<ComponentId, ComponentInstance>;
    arcs: Record<PcbArcId, PcbArc>;
    tracks: Record<TrackId, Track>;
    pads: Record<PadId, Pad>;
    vias: Record<ViaId, Via>;
    regions: Record<RegionId, Region>;
    texts: Record<PcbTextId, PcbText>;
    padstacks: Record<PadstackId, Padstack>;
    board_size: Point;
    board_offset: Point;
    nets: Record<NetId, Net>;
    length_unit: Millimeter;
    angle_unit: Degree;
    [k: string]: unknown | undefined;
};

/**
 * The value of a PCB element field; a union type covering all PCB field
 * types that may appear in a diff result.
 */
export type PcbFieldValue = Angle | PcbArc | undefined | ArcGeometry | boolean | (Border | null) | Meters | (Meters | null) | Pad | undefined | PadstackId | PcbPartMeta | Path | Path[] | Point | Point[] | Region | undefined | string | PcbText | undefined | Track | undefined | Via | undefined;

/**
 * Identifier for a PCB component library entry.
 */
export type PcbLibComponentId = string;

/**
 * The value of a PCB component library element field; a union type covering
 * all PCB library field types that may appear in a diff result.
 */
export type PcbLibFieldValue = Angle | ArcGeometry | boolean | (Border | null) | Meters | (Meters | null) | PadstackId | PcbPartMeta | Path | Path[] | Point | Point[] | string | PcbArc | undefined | PcbLibraryComponentSchema | (string | null) | Pad | undefined | Region | undefined | PcbText | undefined | Track | undefined | Via | undefined;

/**
 * A single footprint in a PCB component library.
 */
export type PcbLibraryComponentSchema = {
    id: PcbLibComponentId;
    name: string;
    description?: string | null;
    arcs: Record<PcbArcId, PcbArc>;
    pads: Record<PadId, Pad>;
    vias: Record<ViaId, Via>;
    tracks: Record<TrackId, Track>;
    texts: Record<PcbTextId, PcbText>;
    regions: Record<RegionId, Region>;
    fonts: Record<FontId, Font>;
    padstacks: Record<PadstackId, Padstack>;
    [k: string]: unknown | undefined;
};

/**
 * Layer and net assignment for a PCB element.
 */
export type PcbPartMeta = {
    layer_id: LayerId;
    net_id?: NetId | null;
    [k: string]: unknown | undefined;
};

/**
 * Text element.
 */
export type PcbText = {
    text: string;
    position: Point;
    /**
     * Absent when zero.
     */
    rotation?: Angle | null;
    width?: Length | null;
    height: Length;
    border?: Border | null;
    font_id: FontId;
    justification: TextJustification;
    is_mirrored: boolean;
    is_designator: boolean;
    is_comment: boolean;
    is_hidden: boolean;
    layer_id: LayerId;
    net_id?: NetId | null;
    net_name?: string | null;
    [k: string]: unknown | undefined;
};

/**
 * PCB text identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type PcbTextId = string;

export type Pin = {
    is_visible?: boolean;
    symbol: SymbolRef;
    name: string;
    display_name?: RichText | null;
    name_color: Color;
    name_font?: FontId | null;
    name_position: PinTextPositionInfo;
    is_name_visible: boolean;
    description: string;
    designator: string;
    designator_font?: FontId | null;
    designator_position: PinTextPositionInfo;
    designator_color: Color;
    is_designator_visible: boolean;
    electrical_type: PinElectricalType;
    net_id?: NetId | null;
    position: Point;
    length: Length;
    color?: Color | null;
    orientation: PinOrientation;
    [k: string]: unknown | undefined;
};

export const PIN_ELECTRICAL_TYPE = {
    INPUT: "Input",
    IO: "Io",
    HI_Z: "HiZ",
    OPEN_COLLECTOR: "OpenCollector",
    OPEN_EMITTER: "OpenEmitter",
    OUTPUT: "Output",
    PASSIVE: "Passive",
    POWER: "Power",
    NO_CONNECT: "NoConnect",
    UNSPECIFIED: "Unspecified",
    POWER_IN: "PowerIn",
    POWER_OUT: "PowerOut"
} as const;
export type PinElectricalType = (typeof PIN_ELECTRICAL_TYPE)[keyof typeof PIN_ELECTRICAL_TYPE];

/**
 * Pin identifier.
 */
export type PinId = string;

export const PIN_ORIENTATION = {
    LEFT: "Left",
    RIGHT: "Right",
    UP: "Up",
    DOWN: "Down"
} as const;
export type PinOrientation = (typeof PIN_ORIENTATION)[keyof typeof PIN_ORIENTATION];

export type PinTextPositionInfo = {
    margin: Length;
    orientation: RelativePinTextOrientation;
    relative_to: PinTextRelativeTo;
    justification?: TextJustification | null;
    [k: string]: unknown | undefined;
};

export const PIN_TEXT_RELATIVE_TO = {
    PIN: "Pin",
    COMPONENT: "Component"
} as const;
export type PinTextRelativeTo = (typeof PIN_TEXT_RELATIVE_TO)[keyof typeof PIN_TEXT_RELATIVE_TO];

/**
 * 2D coordinate.
 */
export type Point = {
    x: Length;
    y: Length;
    [k: string]: unknown | undefined;
};

export type Polygon = {
    id: PolygonId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    points: Point[];
    line_width: Length;
    is_filled: boolean;
    fill_color: Color;
    [k: string]: unknown | undefined;
};

/**
 * Polygon identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type PolygonId = string;

export type Polyline = {
    id: PolylineId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    points: Point[];
    line_width: Length;
    is_filled: boolean;
    fill_color: Color;
    line_style?: LineStyle;
    [k: string]: unknown | undefined;
};

/**
 * Polyline identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type PolylineId = string;

export type Port = {
    id: PortId;
    position: Point;
    rotation: Angle;
    mirrored: boolean;
    name: string;
    net_id?: NetId | null;
    description?: string | null;
    reference?: string | null;
    attributes: Record<ReferenceId, Attribute>;
    pins: Record<ReferenceId, Pin>;
    polylines: Record<ReferenceId, Polyline>;
    polygons: Record<ReferenceId, Polygon>;
    rectangles: Record<ReferenceId, Rectangle>;
    arcs: Record<ReferenceId, SchArc>;
    ellipses: Record<ReferenceId, Ellipse>;
    beziers: Record<ReferenceId, Bezier>;
    bitmaps: Record<ReferenceId, Bitmap>;
    texts: Record<ReferenceId, SchText>;
    [k: string]: unknown | undefined;
};

/**
 * Port identifier.
 */
export type PortId = string;

export type Project = {
    documents: ProjectDocument[];
    variants: Variant[];
    external_design_blocks: ExternalDesignBlock[];
    /**
     * The path of the altium `.prjpcbvariants` file relative to the repo root. Omitted if null.
     */
    altium_project_pcb_variants_file?: string | null;
    [k: string]: unknown | undefined;
};

export type ProjectDocument = {
    id: string;
    /**
     * Relative to the project root. Uses forward slashes as path separator.
     */
    path: string;
    /**
     * The type of ECAD Document. Omitted if null.
     */
    ty?: CadDocumentType | null;
    [k: string]: unknown | undefined;
};

export type ProjectDocumentType = "Project";

/**
 * Top-level ProjectEntry export.
 */
export type ProjectEntryExport = {
    type: ProjectDocumentType;
    /**
     * Path relative to the repo root. Uses forward slashes as path separator.
     */
    path: string;
    project: Project;
    /**
     * Warnings that occurred during the generation of this project
     */
    warnings: Warning[];
    [k: string]: unknown | undefined;
};

export type Pt = number;

export type Rectangle = {
    id: RectangleId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    line_width: Length;
    line_style?: LineStyle;
    is_filled: boolean;
    fill_color: Color;
    bottom_left: Point;
    width: Length;
    height: Length;
    is_transparent: boolean;
    corner_radius?: CornerRadius;
    [k: string]: unknown | undefined;
};

/**
 * Rectangle identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type RectangleId = string;

/**
 * Filled/keepout region.
 */
export type Region = {
    kind: RegionType;
    start: Point;
    cutouts?: Path[];
    layer_id: LayerId;
    net_id?: NetId | null;
    net_name?: string | null;
    [k: string]: unknown | undefined;
};

export type RegionDirective = {
    id: RegionDirectiveId;
    position: Point;
    outline: Color;
    fill: Color;
    collapsed: boolean;
    perimeter: Point[];
    line_style: LineStyle;
    line_width: Meters;
    triangle_line_width: Meters;
    [k: string]: unknown | undefined;
};

/**
 * Region directive identifier.
 */
export type RegionDirectiveId = string;

/**
 * Region identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type RegionId = string;

export const REGION_TYPE = {
    FILL: "Fill",
    CUTOUT: "Cutout",
    KEEP_OUT: "KeepOut",
    CAVITY: "Cavity",
    BOARD_CUTOUT: "BoardCutout"
} as const;
export type RegionType = (typeof REGION_TYPE)[keyof typeof REGION_TYPE];

export const RELATIVE_PIN_TEXT_ORIENTATION = {
    PARALLEL: "Parallel",
    PERPENDICULAR: "Perpendicular"
} as const;
export type RelativePinTextOrientation = (typeof RELATIVE_PIN_TEXT_ORIENTATION)[keyof typeof RELATIVE_PIN_TEXT_ORIENTATION];

export type RichText = {
    display: string;
    /**
     * null when no overlines.
     */
    overlines?: [
        string,
        boolean
    ][] | null;
    component_links?: ComponentLink[] | null;
    [k: string]: unknown | undefined;
};

/**
 * Schematic arc element.
 */
export type SchArc = {
    id: SchArcId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    line_width: Length;
    is_filled: boolean;
    fill_color: Color;
    line_style?: LineStyle;
    center: Point;
    radius_pair: Point;
    bounds_tag: BoundsTag;
    start_angle: Angle;
    end_angle: Angle;
    start_point: Point;
    end_point: Point;
    [k: string]: unknown | undefined;
};

/**
 * Schematic arc identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type SchArcId = string;

export type SchComponent = {
    id: SchComponentId;
    position: Point;
    rotation: Angle;
    mirrored: boolean;
    name: string;
    description?: string | null;
    reference?: string | null;
    logical_reference?: string | null;
    flags?: ComponentFlags;
    attributes: Record<ReferenceId, Attribute>;
    pins: Record<ReferenceId, Pin>;
    polylines: Record<ReferenceId, Polyline>;
    polygons: Record<ReferenceId, Polygon>;
    rectangles: Record<ReferenceId, Rectangle>;
    arcs: Record<ReferenceId, SchArc>;
    ellipses: Record<ReferenceId, Ellipse>;
    beziers: Record<ReferenceId, Bezier>;
    bitmaps: Record<ReferenceId, Bitmap>;
    texts: Record<ReferenceId, SchText>;
    variants?: Record<VariantId, SchComponent | null> | null;
    [k: string]: unknown | undefined;
};

/**
 * Schematic component instance identifier.
 */
export type SchComponentId = string;

/**
 * The value of a schematic element field; a union type covering all
 * schematic field types that may appear in a diff result.
 */
export type SchFieldValue = Angle | ArcGeometry | boolean | Color | CornerRadius | HarnessConnectorSide | ImageId | Meters | LineStyle | (NetId | null) | (string | null) | PinElectricalType | PinTextPositionInfo | Point | Point[] | SheetEntryType | string | SymbolRef | TextJustification | Attribute | Bezier | Bitmap | SchComponent | DirectiveLabel | Ellipse | undefined | Harness | HarnessEntry | undefined | Junction | SchematicNet | NoConnectSymbol | SchematicPage | Pin | undefined | Polygon | undefined | Polyline | undefined | Port | undefined | Rectangle | undefined | RegionDirective | undefined | SchArc | undefined | SheetEntry | undefined | SheetRef | undefined | SchText | undefined | SchemaVariantComponent | Wire | undefined | WireAlias | undefined;

/**
 * Identifier for a schematic component library entry.
 */
export type SchLibComponentId = string;

/**
 * The value of a schematic component library element field; a union type
 * covering all schematic library field types that may appear in a diff result.
 */
export type SchLibFieldValue = Angle | ArcGeometry | boolean | Color | CornerRadius | ImageId | Meters | LineStyle | (NetId | null) | (string | null) | PinElectricalType | PinTextPositionInfo | Point | Point[] | string | SymbolRef | TextJustification | Attribute | Bezier | Bitmap | SchematicLibraryComponentSchema | Ellipse | undefined | Pin | undefined | Polygon | undefined | Polyline | undefined | Rectangle | undefined | SchArc | undefined | SchText | undefined;

/**
 * A single symbol in a multi-symbol schematic component.
 */
export type SchLibSymbol = {
    id: SymbolId;
    [k: string]: unknown | undefined;
};

export type SchText = {
    id: SchTextId;
    symbol: SymbolRef;
    is_visible: boolean;
    color: Color;
    font_id: FontId;
    position: Point;
    justification: TextJustification;
    orientation: Angle;
    text: string;
    display_text?: RichText | null;
    variant_text?: {
        /**
         * @minItems 2
         * @maxItems 2
         */
        [k: string]: [
            string,
            RichText | null
        ] | undefined;
    } | null;
    frame?: TextFrame | null;
    [k: string]: unknown | undefined;
};

/**
 * Schematic text identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type SchTextId = string;

/**
 * A component instance associated with a specific design variant.
 */
export type SchemaVariantComponent = {
    variant_id: string;
    id: SchComponentId;
    position: Point;
    rotation: Angle;
    mirrored: boolean;
    name: string;
    description?: string | null;
    reference?: string | null;
    logical_reference?: string | null;
    flags?: ComponentFlags;
    attributes: Record<ReferenceId, Attribute>;
    pins: Record<ReferenceId, Pin>;
    polylines: Record<ReferenceId, Polyline>;
    polygons: Record<ReferenceId, Polygon>;
    rectangles: Record<ReferenceId, Rectangle>;
    arcs: Record<ReferenceId, SchArc>;
    ellipses: Record<ReferenceId, Ellipse>;
    beziers: Record<ReferenceId, Bezier>;
    bitmaps: Record<ReferenceId, Bitmap>;
    texts: Record<ReferenceId, SchText>;
    variants?: Record<VariantId, SchComponent | null> | null;
    [k: string]: unknown | undefined;
};

export type SchematicComponentLibDocumentType = "SchematicComponentLib";

/**
 * Top-level schematic component library export.
 */
export type SchematicComponentLibExport = {
    type: SchematicComponentLibDocumentType;
    components: SchematicLibraryComponentSchema[];
    [k: string]: unknown | undefined;
};

export type SchematicDocumentType = "Schematic";

/**
 * Top-level schematic export.
 */
export type SchematicExport = {
    type: SchematicDocumentType;
    /**
     * Maps variant ID to variant name. Absent when the schematic has no variants.
     */
    variants?: Record<VariantId, string> | null;
    nets: Record<ReferenceId, SchematicNet>;
    pages: SchematicPage[];
    /**
     * Maps group ID (`pages[].ui_group_id`) to page group, representing a hierarchical structure of groups, each with multiple pages. Absent when hierarchy has not been provided.
     */
    page_groups?: Record<ReferenceId, SchematicPageGroup> | null;
    rendering_hints: SchematicRenderingHints;
    [k: string]: unknown | undefined;
};

/**
 * How the hierarchical relationship among page groups is to be rendered
 *
 * Note: This is an enum rather than a bool because we anticipate needing at
 * least one more mode, flattening only siblings (Altium? KiCad?).
 */
export const SCHEMATIC_HIERARCHY_RENDERING_MODE = {
    FULL: "Full",
    FLAT_GROUPS: "FlatGroups"
} as const;
export type SchematicHierarchyRenderingMode = (typeof SCHEMATIC_HIERARCHY_RENDERING_MODE)[keyof typeof SCHEMATIC_HIERARCHY_RENDERING_MODE];

/**
 * A single component in a schematic component library.
 */
export type SchematicLibraryComponentSchema = {
    id: SchLibComponentId;
    name: string;
    comment?: string | null;
    designator?: string | null;
    description?: string | null;
    part_id?: string | null;
    symbols_map: Record<SymbolId, SchLibSymbol>;
    position: Point;
    rotation: Angle;
    attributes: Record<AttributeId, Attribute>;
    pins: Record<PinId, Pin>;
    polylines: Record<ReferenceId, Polyline>;
    polygons: Record<ReferenceId, Polygon>;
    rectangles: Record<ReferenceId, Rectangle>;
    arcs: Record<ReferenceId, SchArc>;
    ellipses: Record<ReferenceId, Ellipse>;
    beziers: Record<ReferenceId, Bezier>;
    bitmaps: Record<ReferenceId, Bitmap>;
    texts: Record<ReferenceId, SchText>;
    fonts: Record<FontId, Font>;
    [k: string]: unknown | undefined;
};

export type SchematicNet = {
    id: NetId;
    name: string;
    [k: string]: unknown | undefined;
};

export type SchematicPage = {
    id: SchematicPageId;
    name: string;
    /**
     * The schematic file this page was read from, relative to the directory
     * containing the project file and using forward slashes as path
     * separators (for example, `sheets/power.kicad_sch` or
     * `sheets/Power.SchDoc`). This is currently populated for Altium and
     * KiCad project-based conversions, where Hub uses it to map each rendered
     * page to its schematic file in the project diff tree. Other formats are
     * not currently rendered as projects in Hub. Non-project based
     * conversions omit this field.
     */
    source_path?: string | null;
    ui_group_id: SchematicPageGroupId;
    ui_group_name: string;
    page_size: Point;
    border?: PageBorder | null;
    title_blocks: Record<TitleBlockId, TitleBlock>;
    background_color: Color;
    fonts: Record<FontId, Font>;
    wires: Record<ReferenceId, Wire>;
    junctions: Record<ReferenceId, Junction>;
    components: Record<ReferenceId, SchComponent>;
    ports: Record<ReferenceId, Port>;
    sheet_refs: Record<ReferenceId, SheetRef>;
    harnesses?: Record<ReferenceId, Harness>;
    no_connects?: Record<ReferenceId, NoConnectSymbol>;
    graphics: Graphics;
    directive_labels?: Record<ReferenceId, DirectiveLabel>;
    region_directives?: Record<ReferenceId, RegionDirective>;
    net_labels?: Record<ReferenceId, NetLabel>;
    [k: string]: unknown | undefined;
};

export type SchematicPageGroup = {
    id: SchematicPageGroupId;
    display_name: string;
    parent?: SchematicPageGroupParent | null;
    /**
     * Equal between page groups that have been instantiated from the same
     * original data
     *
     * This can be used to match up page groups representing multiple instances
     * of the same hierarchical block.
     *
     * Note: In future versions this may point to an origin page group or other
     * object, but currently it is a separate opaque type just for matching up
     * [`SchematicPageGroup`]s; there is no concrete object assigned this id.
     */
    origin_id?: SchematicPageGroupOriginId | null;
    [k: string]: unknown | undefined;
};

/**
 * Schematic page group identifier.
 */
export type SchematicPageGroupId = string;

/**
 * Schematic page group origin identifier.
 */
export type SchematicPageGroupOriginId = string;

export type SchematicPageGroupParent = {
    id: string;
    reference_in_parent?: SchematicPageGroupParentReference | null;
    [k: string]: unknown | undefined;
};

export type SchematicPageGroupParentReference = {
    parent_page_id: string;
    [k: string]: unknown | undefined;
};

/**
 * Schematic page identifier.
 */
export type SchematicPageId = string;

/**
 * Advice for how the schematic should be visually represented in the frontend
 *
 * These communicate format-, family-, or tool-specific modes that are
 * not covered elsewhere in `Schematic`. This enables the frontend to
 * provide a display consistent with user expectations, without either:
 * 1) introducing inconsistencies in the IR, or
 * 2) requiring the frontend to detect formats and decide how to display them.
 */
export type SchematicRenderingHints = {
    /**
     * Groups should not be displayed as their own nodes in a hierarchical tree
     *
     * This is meant to be set true for input formats (particularly Altium)
     * that do not directly represent groups of pages as multi-page schematic
     * blocks. For consistency with multi-page schematics we have synthesized
     * groups for these (see the discussion in PR 1888), but they will likely
     * be confusing to users of those tools.
     */
    hide_group_nodes: boolean;
    hierarchy_render_mode: SchematicHierarchyRenderingMode;
    [k: string]: unknown | undefined;
};

export type SheetEntry = {
    id: SheetEntryId;
    name: string;
    display_name?: RichText | null;
    entry_type: SheetEntryType;
    net_id?: NetId | null;
    position: Point;
    graphics: Graphics;
    [k: string]: unknown | undefined;
};

/**
 * Sheet entry identifier.
 */
export type SheetEntryId = string;

export const SHEET_ENTRY_TYPE = {
    INPUT: "Input",
    OUTPUT: "Output",
    BI_DIRECTIONAL: "BiDirectional",
    TRI_STATE: "TriState",
    PASSIVE: "Passive"
} as const;
export type SheetEntryType = (typeof SHEET_ENTRY_TYPE)[keyof typeof SHEET_ENTRY_TYPE];

export type SheetRef = {
    id: SheetRefId;
    sheet_name: string;
    filename: string;
    sheet_entries: Record<ReferenceId, SheetEntry>;
    position: Point;
    graphics: Graphics;
    external_sheet: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Sheet reference identifier.
 */
export type SheetRefId = string;

/**
 * Symbol identifier.
 *
 * @format uint16
 * @minimum 0
 * @maximum 65535
 */
export type SymbolId = number;

export type SymbolRef = "AllSymbols" | {
    Symbol: SymbolId;
};

export type TextDecorations = {
    is_underline: boolean;
    is_strikethrough: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Text frame / border box surrounding a `Text` element.
 */
export type TextFrame = {
    position: Point;
    width: Length;
    height: Length;
    line_width: Length;
    line_style?: LineStyle;
    show_border: boolean;
    margin: Length;
    is_filled: boolean;
    fill_color: Color;
    border_color: Color;
    clip_to_bounds: boolean;
    wrap_width?: Meters | null;
    [k: string]: unknown | undefined;
};

export type TextJustification = {
    horizontal: HorizontalJustification;
    vertical: VerticalJustification;
    [k: string]: unknown | undefined;
};

export type TitleBlock = {
    id: TitleBlockId;
    name: string;
    position: Point;
    polylines: Record<ReferenceId, Polyline>;
    polygons: Record<ReferenceId, Polygon>;
    rectangles: Record<ReferenceId, Rectangle>;
    arcs: Record<ReferenceId, SchArc>;
    ellipses: Record<ReferenceId, Ellipse>;
    beziers: Record<ReferenceId, Bezier>;
    bitmaps: Record<ReferenceId, Bitmap>;
    texts: Record<ReferenceId, SchText>;
    attributes: Record<ReferenceId, Attribute>;
    [k: string]: unknown | undefined;
};

/**
 * Title block identifier.
 */
export type TitleBlockId = string;

/**
 * Track (polyline).
 */
export type Track = {
    points: Point[];
    line_width: Length;
    layer_id: LayerId;
    net_id?: NetId | null;
    net_name?: string | null;
    [k: string]: unknown | undefined;
};

/**
 * Track identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type TrackId = string;

export type Variant = {
    id: string;
    description: string;
    [k: string]: unknown | undefined;
};

/**
 * Variant identifier.
 */
export type VariantId = string;

export const VERTICAL_JUSTIFICATION = {
    TOP: "Top",
    CENTER: "Center",
    BOTTOM: "Bottom"
} as const;
export type VerticalJustification = (typeof VERTICAL_JUSTIFICATION)[keyof typeof VERTICAL_JUSTIFICATION];

/**
 * Via.
 */
export type Via = {
    center: Point;
    rotation: Angle;
    padstack: PadstackId;
    net_id?: NetId | null;
    net_name?: string | null;
    [k: string]: unknown | undefined;
};

/**
 * Via identifier. 20-character lowercase hex.
 *
 * @pattern ^[0-9a-f]{20}$
 */
export type ViaId = string;

export type Warning = {
    /**
     * Uses forward slashes as path separator.
     */
    file_path: string;
    detail: string;
    [k: string]: unknown | undefined;
};

export type Wire = {
    id: WireId;
    net_id?: NetId | null;
    p1: Point;
    p2: Point;
    color: Color;
    width: Length;
    line_style?: LineStyle;
    aliases?: Record<ReferenceId, WireAlias>;
    [k: string]: unknown | undefined;
};

export type WireAlias = {
    position: Point;
    color: Color;
    rotation: Angle;
    name: string;
    justification: TextJustification;
    font_id: FontId;
    is_visible: boolean;
    [k: string]: unknown | undefined;
};

/**
 * Wire alias identifier.
 */
export type WireAliasId = string;

/**
 * Wire identifier.
 */
export type WireId = string;
